import request from './adminRequest'

export const appliedCourseApi = {
  listAppliedCourse (params) {
    return request.get('/appliedCourses/', { params: params })
  },
  getAppliedCourse (id) {
    return request.get('/appliedCourses/' + id)
  },
  processAppliedCourse (id, data) {
    return request.put('/appliedCourses/' + id, data)
  },
  deleteAppliedCourse (id) {
    return request.delete('/appliedCourses/' + id)
  },

}
export default appliedCourseApi
